function formatDateTime(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return raw;
  }
  return date.toLocaleString();
}

export function fromApiResponse(item) {
  const recipientCount = Number(item?.recipientCount ?? 0);
  const readCount = Number(item?.readCount ?? 0);
  const readPercent = recipientCount > 0 ? Math.round((readCount / recipientCount) * 100) : 0;

  return {
    uid: String(item?.uid ?? '').trim(),
    subject: String(item?.subject ?? '').trim(),
    body: String(item?.body ?? '').trim(),
    type: String(item?.type ?? 'transactional').trim() || 'transactional',
    targetProfileUid: item?.targetProfileUid ? String(item.targetProfileUid).trim() : null,
    targetCountries: Array.isArray(item?.targetCountries) ? item.targetCountries.map((value) => String(value || '').trim()).filter(Boolean) : [],
    targetAccountTypes: Array.isArray(item?.targetAccountTypes) ? item.targetAccountTypes.map((value) => String(value || '').trim()).filter(Boolean) : [],
    targetProfileStatuses: Array.isArray(item?.targetProfileStatuses) ? item.targetProfileStatuses.map((value) => String(value || '').trim()).filter(Boolean) : [],
    created: String(item?.created ?? '').trim(),
    createdFormatted: formatDateTime(item?.created),
    sentByEmail: String(item?.sentByEmail ?? '').trim(),
    recipientCount,
    readCount,
    readPercent,
  };
}

export function mapInternalMailListResponse(response) {
  const items = response?.messages ?? response?.items ?? response ?? [];
  const list = Array.isArray(items) ? items : Object.values(items);
  return list.map(fromApiResponse);
}
